import { render, staticRenderFns } from "./Organigram.vue?vue&type=template&id=58cf8845&"
import script from "./Organigram.vue?vue&type=script&lang=ts&"
export * from "./Organigram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports